@if (cc.formulas | async; as formulas) {
  <div>
    @if (cc.tables | async; as tables) {
      <div>
        <div style="display: flex; flex-direction: row">
          <mat-form-field style="width: 8rem">
            <mat-label>Input Type</mat-label>
            <mat-select [(value)]="key.type">
              <mat-option value="Question">Question</mat-option>
              <mat-option value="Calculation">Calculation</mat-option>
              @if (caller !== 'Formula') {
                <mat-option value="Formula" [disabled]="formulas.length === 0"> {{ formulas.length !== 0 ? "Formula" : "No Formulas" }}</mat-option>
              }
              @if (caller === 'Formula') {
                <mat-option value="Table">Table</mat-option>
              }
            </mat-select>
          </mat-form-field>
          @if (key.type === 'Calculation') {
            <app-key-select style="margin-left: 1em" [value]="key.keyId" (change)="setKey($event)"></app-key-select>
          }
          @if (key.type === 'Question' && (caller === 'Formula' || caller === 'Package')) {
            <mat-form-field style="margin-left: 1em; width: 30rem">
              <mat-label>Question Input</mat-label>
              <mat-select [(value)]="key.keyId" placeholder="Question Input" (selectionChange)="asPart(key).question = qs.getQuestion(key.keyId)">
                @for (q of qs.numericDraftQuestions | async; track q) {
                  <mat-option [value]="q.id">{{ q.label }}</mat-option>
                }
              </mat-select>
            </mat-form-field>
          }
          @if (key.type === 'Question' && (caller === 'Population' || caller === 'Table')) {
            <mat-form-field style="margin-left: 1em; width: 30rem">
              <mat-label>Question Input</mat-label>
              <mat-select [(value)]="key.keyId" placeholder="Question Input" (selectionChange)="asPart(key).question = qs.getQuestion(key.keyId)">
                @for (q of qs.draftQuestions | async; track q) {
                  <mat-option [value]="q.id">{{ q.label }}</mat-option>
                }
              </mat-select>
            </mat-form-field>
          }
          @if (key.type === 'Formula') {
            <mat-form-field style="margin-left: 1em; width: 30rem">
              <mat-label>Formula Input</mat-label>
              <mat-select [(value)]="asRule(key).formulaId" placeholder="Formula Input" (selectionChange)="setFormula(asRule(key).formulaId)">
                @for (f of formulas; track f) {
                  <mat-option [value]="f.formulaId">{{ f.name }}</mat-option>
                }
              </mat-select>
            </mat-form-field>
          }
          <!-- Only used when called by Formula -->
          @if (key.type === 'Table') {
            <mat-form-field style="margin-left: 1em; width: 30rem">
              <mat-label>Table Input</mat-label>
              <mat-select [(value)]="asTable(key).tableId">
                @for (t of tables; track t) {
                  <mat-option [value]="t.tableId">{{ t.name }}</mat-option>
                }
              </mat-select>
            </mat-form-field>
          }
        </div>
      </div>
    }
  </div>
}
